import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const translations = {
  fr: {
    "lang.name": "Français",
    "nav.home": "Accueil",
    "nav.catalog": "Nos biens",
    "nav.simulator": "Simulateur",
    "nav.services": "Nos services",
    "nav.about": "À propos",
    "nav.contact": "Contact",
    "nav.login": "Connexion",
    "nav.register": "Créer un compte",
    "nav.dashboard": "Mon espace",
    "nav.admin": "Administration",
    "nav.logout": "Déconnexion",

    "hero.badge": "Partenaire Crédit Agricole du Maroc",
    "hero.title": "Investir dans l'immobilier au Maroc, en toute sérénité",
    "hero.subtitle": "Programmes neufs, biens rénovés, entrepôts logistiques et locaux d'entreprise. Une équipe en France et au Maroc gère tout, de A à Z.",
    "hero.cta_explore": "Découvrir les biens",
    "hero.cta_simulate": "Simuler ma mensualité",
    "hero.stat_projects": "Biens sélectionnés",
    "hero.stat_cities": "Villes couvertes",
    "hero.stat_support": "Accompagnement",
    "hook.title": "Investissez et profitez d'un appartement à partir de 250 € / mois",
    "hook.cta": "Calculer ma mensualité",

    "partner.overline": "Financement facilité",
    "partner.title": "Un partenariat avec le Crédit Agricole du Maroc",
    "partner.desc": "Grâce à notre partenariat bancaire, nous facilitons l'accès au crédit immobilier pour les investisseurs résidents et non-résidents. Des conditions négociées et un accompagnement dédié pour concrétiser votre projet.",
    "partner.point1": "Prêts sur 10, 20 et 25 ans",
    "partner.point2": "Dossier accompagné par nos experts",
    "partner.point3": "Solutions résidents & MRE",

    "featured.overline": "Sélection",
    "featured.title": "Nos biens à la une",
    "featured.subtitle": "Une sélection d'opportunités d'investissement au Maroc.",
    "featured.viewall": "Voir tous les biens",

    "types.all": "Tous les biens",
    "types.new_build": "Programme neuf",
    "types.renovation": "Rénovation incluse",
    "types.logistics": "Entrepôt logistique",
    "types.business_premises": "Local d'entreprise",
    "types.residence": "Résidence",
    "types.individual": "Logement individuel",
    "types.commercial": "Local commercial",
    "types.office": "Bureau / Local d'entreprise",

    "services.overline": "Clé en main",
    "services.title": "Toute la logistique gérée par YADIMMO",
    "services.subtitle": "Nous orchestrons chaque étape de votre projet, en France comme sur place.",
    "services.transport_t": "Transport & déplacements",
    "services.transport_d": "Vols, transferts aéroport et déplacements sur place organisés pour vous.",
    "services.stay_t": "Hébergement",
    "services.stay_d": "Séjours confortables pendant vos visites et signatures.",
    "services.tour_t": "Découverte sur place",
    "services.tour_d": "Visites des biens et des points clés de la région avec nos maîtres d'œuvre.",
    "services.legal_t": "Partenaires juridiques",
    "services.legal_d": "Notaires et avocats pour sécuriser chaque transaction.",
    "services.team_t": "Équipe France & Maroc",
    "services.team_d": "Un interlocuteur en France et une équipe dédiée sur place.",
    "services.finance_t": "Financement bancaire",
    "services.finance_d": "Accompagnement crédit via le Crédit Agricole du Maroc.",

    "sim.overline": "Simulateur de financement",
    "sim.title": "Estimez votre mensualité",
    "sim.subtitle": "Prix en dirham marocain, converti en euro, et exprimé en mensualité sur 10, 20 ou 25 ans.",
    "sim.price": "Prix du bien",
    "sim.contribution": "Apport",
    "sim.duration": "Durée du prêt",
    "sim.rate": "Taux d'intérêt annuel",
    "sim.years": "ans",
    "sim.monthly": "Mensualité estimée",
    "sim.loan_amount": "Montant emprunté",
    "sim.total_cost": "Coût total du crédit",
    "sim.disclaimer": "Estimation indicative hors assurance et frais. Le montant définitif dépend de votre dossier bancaire.",
    "sim.rate_live": "Taux de change en temps réel",

    "team.overline": "L'équipe",
    "team.title": "Des experts en France et au Maroc",
    "team.subtitle": "Notaires, avocats, maîtres d'œuvre et conseillers dédiés à votre projet.",

    "contact.overline": "Parlons de votre projet",
    "contact.title": "Contactez-nous",
    "contact.subtitle": "Un projet d'investissement ? Notre équipe vous rappelle sous 24h.",
    "contact.name": "Nom complet",
    "contact.email": "Email",
    "contact.phone": "Téléphone",
    "contact.message": "Votre message",
    "contact.send": "Envoyer ma demande",
    "contact.success": "Demande envoyée ! Notre équipe vous contactera rapidement.",
    "contact.request_info": "Demander des informations",

    "catalog.title": "Nos biens immobiliers",
    "catalog.subtitle": "Trouvez l'investissement qui vous correspond.",
    "catalog.search": "Rechercher une ville, un bien...",
    "catalog.filter_type": "Type de bien",
    "catalog.filter_city": "Ville",
    "catalog.filter_sort": "Trier",
    "catalog.all_cities": "Toutes les villes",
    "catalog.sort_recent": "Plus récents",
    "catalog.sort_price_asc": "Prix croissant",
    "catalog.sort_price_desc": "Prix décroissant",
    "catalog.results": "biens trouvés",
    "catalog.empty": "Aucun bien ne correspond à votre recherche.",

    "prop.from": "À partir de",
    "prop.surface": "Surface",
    "prop.bedrooms": "Chambres",
    "prop.bathrooms": "SdB",
    "prop.delivery": "Livraison",
    "prop.features": "Prestations",
    "prop.similar": "Biens similaires",
    "prop.interested": "Ce bien vous intéresse ?",
    "prop.back": "Retour aux biens",
    "prop.monthly_from": "soit",
    "prop.per_month": "/ mois",
    "prop.typo_eyebrow": "Lots & typologies",
    "prop.typo_title": "Typologies disponibles",
    "prop.typo_sub": "Choisissez la typologie qui correspond à votre projet. Prix indicatifs « à partir de ».",
    "prop.plans_title": "Plans par étage",
    "prop.units_available": "lots disponibles",
    "prop.many_units": "Nombreux lots",
    "prop.terrace": "Terrasse",
    "prop.on_request": "Sur demande",
    "prop.check_availability": "Demander la disponibilité",
    "prop.in_project": "Disponible dans ce projet",
    "prop.in_project_sub": "Découvrez les autres lots disponibles dans la même résidence.",
    "prop.view_all_project": "Voir toutes les offres du projet",
    "prop.ref": "Réf.",
    "prop.floor_label": "Étage",

    "auth.login_title": "Connexion à votre espace",
    "auth.register_title": "Créer votre compte investisseur",
    "auth.name": "Nom complet",
    "auth.email": "Email",
    "auth.password": "Mot de passe",
    "auth.phone": "Téléphone",
    "auth.login_btn": "Se connecter",
    "auth.register_btn": "Créer mon compte",
    "auth.no_account": "Pas encore de compte ?",
    "auth.have_account": "Déjà inscrit ?",
    "auth.forgot": "Mot de passe oublié ?",
    "auth.login_success": "Connexion réussie",
    "auth.register_success": "Compte créé avec succès",

    "dash.title": "Mon espace investisseur",
    "dash.welcome": "Bienvenue",
    "dash.favorites": "Mes biens favoris",
    "dash.no_favorites": "Vous n'avez pas encore de favoris. Explorez nos biens et ajoutez vos coups de cœur.",
    "dash.profile": "Mon profil",

    "admin.title": "Administration YADIMMO",
    "admin.properties": "Biens",
    "admin.leads": "Demandes de contact",
    "admin.users": "Investisseurs",
    "admin.new_property": "Ajouter un bien",
    "admin.edit": "Modifier",
    "admin.delete": "Supprimer",
    "admin.save": "Enregistrer",
    "admin.cancel": "Annuler",
    "admin.confirm_delete": "Supprimer ce bien ?",
    "admin.dashboard": "Tableau de bord",
    "admin.new_leads": "Nouveaux",
    "admin.handle": "Traiter",
    "admin.added": "Bien ajouté", "admin.modified": "Bien modifié", "admin.deleted": "Supprimé",
    "admin.f_title": "Titre", "admin.f_desc": "Description", "admin.f_city": "Ville", "admin.f_region": "Région",
    "admin.f_price": "Prix (MAD)", "admin.f_surface": "Surface m²", "admin.f_bedrooms": "Chambres", "admin.f_bathrooms": "SdB",
    "admin.f_delivery": "Livraison", "admin.f_images": "Photos du bien", "admin.f_features": "Prestations (séparées par des virgules)",
    "admin.f_featured": "Mettre à la une (featured)",
    "admin.tab_dossiers": "Dossiers financement",
    "admin.search_ph": "Rechercher un bien…",
    "admin.bien": "Bien", "admin.col_contacts": "Contacts", "admin.col_favoris": "Favoris",
    "admin.col_rdv": "RDV", "admin.col_dossiers": "Dossiers", "admin.status": "Statut", "admin.client": "Client",
    "admin.showing": "affichés",
    "admin.tab_rdv": "Rendez-vous",
    "admin.tab_chats": "Chats José",
    "rdv.accept": "Accepter", "rdv.decline": "Décliner", "rdv.reschedule": "Décaler", "rdv.assign": "Affecter à",
    "rdv.unassigned": "Non affecté", "rdv.when": "Date", "rdv.subject": "Objet",
    "rdv.requested": "En attente", "rdv.confirmed": "Confirmé", "rdv.rescheduled": "Reporté", "rdv.declined": "Refusé",
    "admin.upload_images": "Téléverser des images", "admin.uploading": "Téléversement…", "admin.or_url": "Ou coller des URLs (une par ligne)",

    "footer.tagline": "Bâtir & Grandir en 1 seul mot.",
    "footer.rights": "Tous droits réservés.",
    "footer.quick": "Navigation",
    "footer.contact": "Contact",

    "common.loading": "Chargement...",
    "nav.cost": "Coût de la vie",
    "nav.blog": "Blog",
    "profiles.title": "Quel investisseur êtes-vous ?",
    "profiles.subtitle": "Le Maroc s'adapte à chaque projet de vie et de rendement.",
    "profiles.explore": "Explorer",
    "profiles.retirement_t": "Retraite au soleil",
    "profiles.retirement_d": "Installez votre résidence principale au Maroc : climat doux, coût de la vie réduit et cadre serein.",
    "profiles.secondary_t": "Résidence secondaire",
    "profiles.secondary_d": "Un pied-à-terre ensoleillé à quelques heures de l'Europe, à occuper ou à louer selon vos envies.",
    "profiles.rental_t": "Investissement locatif",
    "profiles.rental_d": "Des rendements attractifs dans les villes qui montent. Gestion locative assurée par YADIMMO.",
    "profiles.logistics_t": "Logistique stratégique",
    "profiles.logistics_d": "Entrepôts aux portes de l'Europe (Tanger Med), tremplin vers l'Afrique et l'Asie.",
    "profiles.business_t": "Implantation d'entreprise",
    "profiles.business_d": "Locaux et zones franches pour développer votre activité, conciergerie clé en main.",
    "profiles.budget_t": "Optimiser son budget",
    "profiles.budget_d": "Comparez le coût de la vie et suivez le change dirham/euro avant d'investir.",
    "conv.note": "(cours indicatif)",
    "col.title": "Coût de la vie & change",
    "col.subtitle": "Suivez le cours du dirham marocain face à l'euro et comparez le coût de la vie au Maroc avec la France. Un pouvoir d'achat qui change tout pour votre projet.",
    "col.compare": "Maroc vs France — le comparatif",
    "col.item": "Poste", "col.morocco": "Maroc", "col.france": "France", "col.gap": "Écart",
    "col.note": "Valeurs indicatives converties au cours en temps réel. Les prix réels varient selon la ville et la période.",
    "col.cta_title": "Prêt à investir avec ce pouvoir d'achat ?", "col.cta_btn": "Découvrir nos biens",
    "col.rent": "Loyer appartement 1 ch. (centre)", "col.internet": "Internet fibre", "col.electricity": "Électricité (foyer)",
    "col.fuel": "Carburant (essence)", "col.restaurant": "Repas au restaurant", "col.groceries": "Panier de courses",
    "col.transport": "Ticket de transport", "col.coffee": "Café",
    "col.per_month": "/ mois", "col.per_liter": "/ litre", "col.per_week": "/ semaine",
    "blog.title": "Le blog YADIMMO", "blog.subtitle": "Conseils, analyses et guides pour investir sereinement dans l'immobilier au Maroc.",
    "blog.read": "Lire", "blog.min": "min", "blog.all": "Tous les articles", "blog.generating": "Rédaction de l'article…",
    "blog.cta_title": "Envie d'investir au Maroc ?", "blog.cta_text": "Notre équipe (Aix-en-Provence & Marrakech) vous accompagne de A à Z.", "blog.cta_btn": "Voir les biens",
    "legal.eyebrow": "Informations légales",
    "inv.title": "Mon espace investisseur",
    "inv.tab_project": "Mon projet", "inv.tab_appointments": "Rendez-vous", "inv.tab_alerts": "Mes alertes", "inv.tab_favorites": "Favoris",
    "inv.tab_request": "Demander un bien",
    "req.title": "Demande de bien sur mesure", "req.sub": "Décrivez le bien recherché, notre équipe vous recontacte avec des opportunités adaptées.",
    "req.type": "Type de bien", "req.city": "Ville souhaitée", "req.budget": "Budget max (MAD)", "req.msg": "Précisez votre besoin (surface, quartier, usage…)",
    "req.submit": "Envoyer ma demande", "req.sent": "Demande envoyée ! Notre équipe vous recontacte.",
    "inv.fin_t": "Achat & financement", "inv.fin_d": "Constituer mon dossier de crédit avec le Crédit Agricole du Maroc.",
    "inv.plc_t": "Placement / investissement", "inv.plc_d": "Être conseillé par un expert sur un placement immobilier.",
    "inv.imp_t": "Implantation d'entreprise", "inv.imp_d": "Conciergerie clé en main pour implanter mon activité au Maroc.",
    "inv.dossier": "Dossier de financement", "inv.progress": "Progression du dossier", "inv.change": "Changer de projet",
    "inv.upload": "Téléverser", "inv.replace": "Remplacer", "inv.submit": "Déposer mon dossier en banque", "inv.bank_note": "Note de la banque :",
    "inv.appt_slots": "Créneaux disponibles",
    "inv.appt_intro": "Prenez rendez-vous avec un expert du service client YADIMMO. La conciergerie (transport, hébergement, découverte sur place, implantation clé en main) est assurée par nos équipes.",
    "inv.no_slots": "Aucun créneau pour le moment.", "inv.no_appt": "Aucun rendez-vous. Choisissez un créneau dans l'onglet « Mon projet ».",
    "inv.no_fav": "Aucun favori pour l'instant.", "inv.rdv_confirmed": "Rendez-vous confirmé",
    "inv.subject": "Sujet", "inv.with": "avec", "inv.implantation": "Implantation d'entreprise", "inv.placement": "Placement / conseil",
    "st.draft": "Brouillon", "st.submitted": "Déposé en banque", "st.in_review": "En cours d'étude", "st.approved": "Accepté", "st.rejected": "Refusé",
    "alerts.create": "Créer une alerte", "alerts.city_ph": "Ville (ex. Marrakech)", "alerts.min_ph": "Budget min (MAD)", "alerts.max_ph": "Budget max (MAD)",
    "alerts.note_ph": "Précisions (optionnel)", "alerts.create_btn": "Créer l'alerte", "alerts.created": "Alerte créée. Le service client est informé de vos attentes.",
    "alerts.empty": "Aucune alerte. José peut aussi en créer pour vous depuis le chat.", "alerts.all_cities": "toutes villes", "alerts.type_any": "Tout type",
    "svc.title": "Tableau de bord conciergerie", "svc.role": "Service client",
    "svc.tab_rdv": "RDV", "svc.tab_slots": "Créneaux", "svc.tab_leads": "Leads", "svc.tab_expect": "Attentes clients",
    "svc.add_slot": "Ajouter un créneau (45 min)", "svc.add": "Ajouter", "svc.slot_added": "Créneau ajouté",
    "svc.no_rdv": "Aucun rendez-vous planifié.", "svc.no_slots": "Aucun créneau libre. Ajoutez-en ci-dessus.",
    "svc.no_leads": "Aucun lead.", "svc.no_expect": "Aucune attente client enregistrée.",
    "svc.via_jose": "via José", "svc.mark_handled": "Marquer traité", "svc.handled": "traité", "svc.prospect": "Prospect",
    "bank.title": "Dossiers de financement", "bank.eyebrow": "Espace bancaire", "bank.empty": "Aucun dossier déposé pour l'instant.",
    "bank.review": "Mettre en étude", "bank.approve": "Accepter", "bank.reject": "Refuser", "bank.missing": "manquant", "bank.view": "Voir",
    "bank.note_prompt": "Note à destination de l'investisseur (optionnel) :", "bank.updated": "Statut mis à jour",
    "st.saved": "Enregistré",
    "common.mad": "MAD",
    "common.eur": "€",
  },
  en: {
    "lang.name": "English",
    "nav.home": "Home",
    "nav.catalog": "Properties",
    "nav.simulator": "Simulator",
    "nav.services": "Services",
    "nav.about": "About",
    "nav.contact": "Contact",
    "nav.login": "Log in",
    "nav.register": "Sign up",
    "nav.dashboard": "My account",
    "nav.admin": "Administration",
    "nav.logout": "Log out",

    "hero.badge": "Crédit Agricole du Maroc Partner",
    "hero.title": "Invest in Moroccan real estate with total peace of mind",
    "hero.subtitle": "New-build programs, renovated properties, logistics warehouses and business premises. A team in France and Morocco handles everything, from A to Z.",
    "hero.cta_explore": "Explore properties",
    "hero.cta_simulate": "Simulate my payment",
    "hero.stat_projects": "Selected properties",
    "hero.stat_cities": "Cities covered",
    "hero.stat_support": "Full support",
    "hook.title": "Invest and enjoy an apartment from €250 / month",
    "hook.cta": "Calculate my payment",

    "partner.overline": "Easier financing",
    "partner.title": "A partnership with Crédit Agricole du Maroc",
    "partner.desc": "Thanks to our banking partnership, we make real-estate credit easier for resident and non-resident investors. Negotiated terms and dedicated support to make your project happen.",
    "partner.point1": "Loans over 10, 20 and 25 years",
    "partner.point2": "Application supported by our experts",
    "partner.point3": "Resident & expat solutions",

    "featured.overline": "Selection",
    "featured.title": "Featured properties",
    "featured.subtitle": "A curated selection of investment opportunities in Morocco.",
    "featured.viewall": "View all properties",

    "types.all": "All properties",
    "types.new_build": "New build",
    "types.renovation": "Renovation included",
    "types.logistics": "Logistics warehouse",
    "types.business_premises": "Business premises",
    "types.residence": "Residence",
    "types.individual": "Individual home",
    "types.commercial": "Retail unit",
    "types.office": "Office / Business unit",

    "services.overline": "Turnkey",
    "services.title": "All logistics handled by YADIMMO",
    "services.subtitle": "We orchestrate every step of your project, in France and on site.",
    "services.transport_t": "Transport & travel",
    "services.transport_d": "Flights, airport transfers and on-site travel organized for you.",
    "services.stay_t": "Accommodation",
    "services.stay_d": "Comfortable stays during your visits and signings.",
    "services.tour_t": "On-site discovery",
    "services.tour_d": "Property visits and key regional highlights with our works supervisors.",
    "services.legal_t": "Legal partners",
    "services.legal_d": "Notaries and lawyers to secure every transaction.",
    "services.team_t": "France & Morocco team",
    "services.team_d": "A contact in France and a dedicated team on site.",
    "services.finance_t": "Bank financing",
    "services.finance_d": "Credit support via Crédit Agricole du Maroc.",

    "sim.overline": "Financing simulator",
    "sim.title": "Estimate your monthly payment",
    "sim.subtitle": "Price in Moroccan dirham, converted to euro, expressed as a monthly payment over 10, 20 or 25 years.",
    "sim.price": "Property price",
    "sim.contribution": "Down payment",
    "sim.duration": "Loan term",
    "sim.rate": "Annual interest rate",
    "sim.years": "years",
    "sim.monthly": "Estimated monthly payment",
    "sim.loan_amount": "Loan amount",
    "sim.total_cost": "Total credit cost",
    "sim.disclaimer": "Indicative estimate excluding insurance and fees. The final amount depends on your bank application.",
    "sim.rate_live": "Live exchange rate",

    "team.overline": "The team",
    "team.title": "Experts in France and Morocco",
    "team.subtitle": "Notaries, lawyers, works supervisors and advisors dedicated to your project.",

    "contact.overline": "Let's talk about your project",
    "contact.title": "Contact us",
    "contact.subtitle": "An investment project? Our team calls you back within 24h.",
    "contact.name": "Full name",
    "contact.email": "Email",
    "contact.phone": "Phone",
    "contact.message": "Your message",
    "contact.send": "Send my request",
    "contact.success": "Request sent! Our team will contact you soon.",
    "contact.request_info": "Request information",

    "catalog.title": "Our properties",
    "catalog.subtitle": "Find the investment that suits you.",
    "catalog.search": "Search a city, a property...",
    "catalog.filter_type": "Property type",
    "catalog.filter_city": "City",
    "catalog.filter_sort": "Sort",
    "catalog.all_cities": "All cities",
    "catalog.sort_recent": "Most recent",
    "catalog.sort_price_asc": "Price low to high",
    "catalog.sort_price_desc": "Price high to low",
    "catalog.results": "properties found",
    "catalog.empty": "No property matches your search.",

    "prop.from": "From",
    "prop.surface": "Surface",
    "prop.bedrooms": "Bedrooms",
    "prop.bathrooms": "Baths",
    "prop.delivery": "Delivery",
    "prop.features": "Amenities",
    "prop.similar": "Similar properties",
    "prop.interested": "Interested in this property?",
    "prop.back": "Back to properties",
    "prop.monthly_from": "i.e.",
    "prop.per_month": "/ month",
    "prop.typo_eyebrow": "Units & layouts",
    "prop.typo_title": "Available layouts",
    "prop.typo_sub": "Choose the layout that fits your project. Indicative \"from\" prices.",
    "prop.plans_title": "Floor plans",
    "prop.units_available": "units available",
    "prop.many_units": "Many units",
    "prop.terrace": "Terrace",
    "prop.on_request": "On request",
    "prop.check_availability": "Check availability",
    "prop.in_project": "Available in this project",
    "prop.in_project_sub": "Discover the other units available in the same residence.",
    "prop.view_all_project": "View all units in this project",
    "prop.ref": "Ref.",
    "prop.floor_label": "Floor",

    "auth.login_title": "Log in to your account",
    "auth.register_title": "Create your investor account",
    "auth.name": "Full name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.phone": "Phone",
    "auth.login_btn": "Log in",
    "auth.register_btn": "Create my account",
    "auth.no_account": "No account yet?",
    "auth.have_account": "Already registered?",
    "auth.forgot": "Forgot password?",
    "auth.login_success": "Logged in successfully",
    "auth.register_success": "Account created successfully",

    "dash.title": "My investor space",
    "dash.welcome": "Welcome",
    "dash.favorites": "My favorite properties",
    "dash.no_favorites": "You have no favorites yet. Explore our properties and add your favorites.",
    "dash.profile": "My profile",

    "admin.title": "YADIMMO Administration",
    "admin.properties": "Properties",
    "admin.leads": "Contact requests",
    "admin.users": "Investors",
    "admin.new_property": "Add property",
    "admin.edit": "Edit",
    "admin.delete": "Delete",
    "admin.save": "Save",
    "admin.cancel": "Cancel",
    "admin.confirm_delete": "Delete this property?",
    "admin.dashboard": "Dashboard",
    "admin.new_leads": "New",
    "admin.handle": "Handle",
    "admin.added": "Property added", "admin.modified": "Property updated", "admin.deleted": "Deleted",
    "admin.f_title": "Title", "admin.f_desc": "Description", "admin.f_city": "City", "admin.f_region": "Region",
    "admin.f_price": "Price (MAD)", "admin.f_surface": "Surface m²", "admin.f_bedrooms": "Bedrooms", "admin.f_bathrooms": "Baths",
    "admin.f_delivery": "Delivery", "admin.f_images": "Property photos", "admin.f_features": "Amenities (comma-separated)",
    "admin.f_featured": "Feature on homepage",
    "admin.tab_dossiers": "Financing files",
    "admin.search_ph": "Search a property…",
    "admin.bien": "Property", "admin.col_contacts": "Contacts", "admin.col_favoris": "Saved",
    "admin.col_rdv": "Appts", "admin.col_dossiers": "Files", "admin.status": "Status", "admin.client": "Client",
    "admin.showing": "shown",
    "admin.tab_rdv": "Appointments",
    "admin.tab_chats": "Chats",
    "rdv.accept": "Accept", "rdv.decline": "Decline", "rdv.reschedule": "Reschedule", "rdv.assign": "Assign to",
    "rdv.unassigned": "Unassigned", "rdv.when": "Date", "rdv.subject": "Subject",
    "rdv.requested": "Pending", "rdv.confirmed": "Confirmed", "rdv.rescheduled": "Rescheduled", "rdv.declined": "Declined",
    "admin.upload_images": "Upload images", "admin.uploading": "Uploading…", "admin.or_url": "Or paste URLs (one per line)",

    "footer.tagline": "Build & Grow in a single word.",
    "footer.rights": "All rights reserved.",
    "footer.quick": "Navigation",
    "footer.contact": "Contact",

    "common.loading": "Loading...",
    "nav.cost": "Cost of living", "nav.blog": "Blog",
    "profiles.title": "What kind of investor are you?",
    "profiles.subtitle": "Morocco fits every life and yield project.",
    "profiles.explore": "Explore",
    "profiles.retirement_t": "Retire in the sun",
    "profiles.retirement_d": "Make Morocco your main residence: mild climate, lower cost of living and a serene setting.",
    "profiles.secondary_t": "Second home",
    "profiles.secondary_d": "A sunny base a few hours from Europe, to live in or rent out as you wish.",
    "profiles.rental_t": "Buy-to-let investment",
    "profiles.rental_d": "Attractive yields in rising cities. Rental management handled by YADIMMO.",
    "profiles.logistics_t": "Strategic logistics",
    "profiles.logistics_d": "Warehouses at Europe's doorstep (Tanger Med), a gateway to Africa and Asia.",
    "profiles.business_t": "Business setup",
    "profiles.business_d": "Premises and free zones to grow your business, turnkey concierge service.",
    "profiles.budget_t": "Optimise your budget",
    "profiles.budget_d": "Compare the cost of living and track the dirham/euro rate before investing.",
    "conv.note": "(indicative rate)",
    "col.title": "Cost of living & exchange",
    "col.subtitle": "Track the Moroccan dirham against the euro and compare the cost of living in Morocco with France. Purchasing power that changes everything for your project.",
    "col.compare": "Morocco vs France — the comparison",
    "col.item": "Item", "col.morocco": "Morocco", "col.france": "France", "col.gap": "Gap",
    "col.note": "Indicative values converted at the live rate. Actual prices vary by city and period.",
    "col.cta_title": "Ready to invest with this purchasing power?", "col.cta_btn": "Discover our properties",
    "col.rent": "1-bed apartment rent (centre)", "col.internet": "Fibre internet", "col.electricity": "Electricity (home)",
    "col.fuel": "Fuel (petrol)", "col.restaurant": "Restaurant meal", "col.groceries": "Weekly groceries",
    "col.transport": "Transport ticket", "col.coffee": "Coffee",
    "col.per_month": "/ month", "col.per_liter": "/ litre", "col.per_week": "/ week",
    "blog.title": "The YADIMMO blog", "blog.subtitle": "Tips, analysis and guides to invest with confidence in Moroccan real estate.",
    "blog.read": "Read", "blog.min": "min", "blog.all": "All articles", "blog.generating": "Writing the article…",
    "blog.cta_title": "Want to invest in Morocco?", "blog.cta_text": "Our team (Aix-en-Provence & Marrakech) supports you from A to Z.", "blog.cta_btn": "View properties",
    "legal.eyebrow": "Legal information",
    "inv.title": "My investor space",
    "inv.tab_project": "My project", "inv.tab_appointments": "Appointments", "inv.tab_alerts": "My alerts", "inv.tab_favorites": "Favorites",
    "inv.tab_request": "Request a property",
    "req.title": "Tailored property request", "req.sub": "Describe the property you are looking for; our team will get back to you with matching opportunities.",
    "req.type": "Property type", "req.city": "Preferred city", "req.budget": "Max budget (MAD)", "req.msg": "Describe your need (size, area, use…)",
    "req.submit": "Send my request", "req.sent": "Request sent! Our team will contact you.",
    "inv.fin_t": "Purchase & financing", "inv.fin_d": "Build my credit file with Crédit Agricole du Maroc.",
    "inv.plc_t": "Investment / placement", "inv.plc_d": "Get advice from an expert on a real-estate placement.",
    "inv.imp_t": "Business setup", "inv.imp_d": "Turnkey concierge to set up my business in Morocco.",
    "inv.dossier": "Financing file", "inv.progress": "File progress", "inv.change": "Change project",
    "inv.upload": "Upload", "inv.replace": "Replace", "inv.submit": "Submit my file to the bank", "inv.bank_note": "Bank note:",
    "inv.appt_slots": "Available slots",
    "inv.appt_intro": "Book an appointment with a YADIMMO customer-service expert. Concierge (transport, accommodation, on-site discovery, turnkey setup) is handled by our teams.",
    "inv.no_slots": "No slots for now.", "inv.no_appt": "No appointment. Pick a slot in the 'My project' tab.",
    "inv.no_fav": "No favorites yet.", "inv.rdv_confirmed": "Appointment confirmed",
    "inv.subject": "Subject", "inv.with": "with", "inv.implantation": "Business setup", "inv.placement": "Placement / advice",
    "st.draft": "Draft", "st.submitted": "Submitted to bank", "st.in_review": "Under review", "st.approved": "Approved", "st.rejected": "Rejected",
    "alerts.create": "Create an alert", "alerts.city_ph": "City (e.g. Marrakech)", "alerts.min_ph": "Min budget (MAD)", "alerts.max_ph": "Max budget (MAD)",
    "alerts.note_ph": "Details (optional)", "alerts.create_btn": "Create alert", "alerts.created": "Alert created. Customer service is informed of your expectations.",
    "alerts.empty": "No alert. José can also create one for you from the chat.", "alerts.all_cities": "all cities", "alerts.type_any": "Any type",
    "svc.title": "Concierge dashboard", "svc.role": "Customer service",
    "svc.tab_rdv": "Appointments", "svc.tab_slots": "Slots", "svc.tab_leads": "Leads", "svc.tab_expect": "Client expectations",
    "svc.add_slot": "Add a slot (45 min)", "svc.add": "Add", "svc.slot_added": "Slot added",
    "svc.no_rdv": "No scheduled appointment.", "svc.no_slots": "No free slot. Add some above.",
    "svc.no_leads": "No lead.", "svc.no_expect": "No client expectation recorded.",
    "svc.via_jose": "via José", "svc.mark_handled": "Mark handled", "svc.handled": "handled", "svc.prospect": "Prospect",
    "bank.title": "Financing files", "bank.eyebrow": "Banking space", "bank.empty": "No file submitted yet.",
    "bank.review": "Set under review", "bank.approve": "Approve", "bank.reject": "Reject", "bank.missing": "missing", "bank.view": "View",
    "bank.note_prompt": "Note for the investor (optional):", "bank.updated": "Status updated", "st.saved": "Saved",
    "common.mad": "MAD",
    "common.eur": "€",
  },
  ar: {
    "lang.name": "العربية",
    "nav.home": "الرئيسية",
    "nav.catalog": "عقاراتنا",
    "nav.simulator": "المحاكي",
    "nav.services": "خدماتنا",
    "nav.about": "من نحن",
    "nav.contact": "اتصل بنا",
    "nav.login": "تسجيل الدخول",
    "nav.register": "إنشاء حساب",
    "nav.dashboard": "حسابي",
    "nav.admin": "الإدارة",
    "nav.logout": "تسجيل الخروج",

    "hero.badge": "شريك القرض الفلاحي المغربي",
    "hero.title": "استثمر في العقارات بالمغرب بكل اطمئنان",
    "hero.subtitle": "برامج جديدة، عقارات مجددة، مستودعات لوجستية ومحلات تجارية. فريق في فرنسا والمغرب يتكفل بكل شيء من الألف إلى الياء.",
    "hero.cta_explore": "اكتشف العقارات",
    "hero.cta_simulate": "احسب قسطي الشهري",
    "hero.stat_projects": "عقارات مختارة",
    "hero.stat_cities": "مدن مغطاة",
    "hero.stat_support": "مرافقة كاملة",
    "hook.title": "استثمر واستمتع بشقة ابتداءً من 250 أورو / شهرياً",
    "hook.cta": "احسب قسطي",

    "partner.overline": "تمويل ميسّر",
    "partner.title": "شراكة مع القرض الفلاحي المغربي",
    "partner.desc": "بفضل شراكتنا البنكية، نسهّل الحصول على القرض العقاري للمستثمرين المقيمين وغير المقيمين. شروط تفاوضية ومرافقة مخصصة لتحقيق مشروعك.",
    "partner.point1": "قروض على 10 و20 و25 سنة",
    "partner.point2": "ملف مرافق من طرف خبرائنا",
    "partner.point3": "حلول للمقيمين ومغاربة العالم",

    "featured.overline": "مختارات",
    "featured.title": "عقارات مميزة",
    "featured.subtitle": "مجموعة مختارة من فرص الاستثمار بالمغرب.",
    "featured.viewall": "عرض كل العقارات",

    "types.all": "كل العقارات",
    "types.new_build": "برنامج جديد",
    "types.renovation": "تجديد مشمول",
    "types.logistics": "مستودع لوجستي",
    "types.business_premises": "محل تجاري",
    "types.residence": "إقامة",
    "types.individual": "سكن فردي",
    "types.commercial": "محل تجاري",
    "types.office": "مكتب / محل تجاري",

    "services.overline": "جاهز للاستعمال",
    "services.title": "كل اللوجستيك تتكفل به YADIMMO",
    "services.subtitle": "ننظم كل مراحل مشروعك، في فرنسا وعلى عين المكان.",
    "services.transport_t": "النقل والتنقلات",
    "services.transport_d": "رحلات جوية ونقل من المطار وتنقلات محلية منظمة لأجلك.",
    "services.stay_t": "الإقامة",
    "services.stay_d": "إقامات مريحة خلال زياراتك وتوقيعاتك.",
    "services.tour_t": "الاكتشاف الميداني",
    "services.tour_d": "زيارات العقارات وأهم معالم المنطقة مع مهندسينا.",
    "services.legal_t": "شركاء قانونيون",
    "services.legal_d": "موثقون ومحامون لتأمين كل معاملة.",
    "services.team_t": "فريق فرنسا والمغرب",
    "services.team_d": "مسؤول في فرنسا وفريق مخصص على عين المكان.",
    "services.finance_t": "التمويل البنكي",
    "services.finance_d": "مرافقة القرض عبر القرض الفلاحي المغربي.",

    "sim.overline": "محاكي التمويل",
    "sim.title": "احسب قسطك الشهري",
    "sim.subtitle": "الثمن بالدرهم المغربي، محول إلى الأورو، ومعبر عنه كقسط شهري على 10 أو 20 أو 25 سنة.",
    "sim.price": "ثمن العقار",
    "sim.contribution": "المساهمة",
    "sim.duration": "مدة القرض",
    "sim.rate": "نسبة الفائدة السنوية",
    "sim.years": "سنوات",
    "sim.monthly": "القسط الشهري المقدّر",
    "sim.loan_amount": "مبلغ القرض",
    "sim.total_cost": "التكلفة الإجمالية للقرض",
    "sim.disclaimer": "تقدير إرشادي بدون التأمين والمصاريف. المبلغ النهائي يتوقف على ملفك البنكي.",
    "sim.rate_live": "سعر الصرف مباشر",

    "team.overline": "الفريق",
    "team.title": "خبراء في فرنسا والمغرب",
    "team.subtitle": "موثقون، محامون، مهندسون ومستشارون مخصصون لمشروعك.",

    "contact.overline": "لنتحدث عن مشروعك",
    "contact.title": "اتصل بنا",
    "contact.subtitle": "مشروع استثماري؟ فريقنا يعاود الاتصال بك خلال 24 ساعة.",
    "contact.name": "الاسم الكامل",
    "contact.email": "البريد الإلكتروني",
    "contact.phone": "الهاتف",
    "contact.message": "رسالتك",
    "contact.send": "إرسال طلبي",
    "contact.success": "تم إرسال الطلب! سيتصل بك فريقنا قريباً.",
    "contact.request_info": "طلب معلومات",

    "catalog.title": "عقاراتنا",
    "catalog.subtitle": "اعثر على الاستثمار المناسب لك.",
    "catalog.search": "ابحث عن مدينة أو عقار...",
    "catalog.filter_type": "نوع العقار",
    "catalog.filter_city": "المدينة",
    "catalog.filter_sort": "ترتيب",
    "catalog.all_cities": "كل المدن",
    "catalog.sort_recent": "الأحدث",
    "catalog.sort_price_asc": "السعر تصاعدي",
    "catalog.sort_price_desc": "السعر تنازلي",
    "catalog.results": "عقار موجود",
    "catalog.empty": "لا يوجد عقار يطابق بحثك.",

    "prop.from": "ابتداءً من",
    "prop.surface": "المساحة",
    "prop.bedrooms": "غرف النوم",
    "prop.bathrooms": "حمامات",
    "prop.delivery": "التسليم",
    "prop.features": "الخدمات",
    "prop.similar": "عقارات مشابهة",
    "prop.interested": "هل يهمك هذا العقار؟",
    "prop.back": "العودة إلى العقارات",
    "prop.monthly_from": "أي",
    "prop.per_month": "/ شهر",
    "prop.typo_eyebrow": "الشقق والأنماط",
    "prop.typo_title": "الأنماط المتاحة",
    "prop.typo_sub": "اختر النمط المناسب لمشروعك. أسعار إرشادية «ابتداءً من».",
    "prop.plans_title": "مخططات الطوابق",
    "prop.units_available": "وحدات متاحة",
    "prop.many_units": "وحدات عديدة",
    "prop.terrace": "شرفة",
    "prop.on_request": "عند الطلب",
    "prop.check_availability": "طلب التوفر",
    "prop.in_project": "متاح في هذا المشروع",
    "prop.in_project_sub": "اكتشف الوحدات الأخرى المتاحة في نفس الإقامة.",
    "prop.view_all_project": "عرض جميع وحدات المشروع",
    "prop.ref": "المرجع",
    "prop.floor_label": "الطابق",

    "auth.login_title": "الدخول إلى حسابك",
    "auth.register_title": "أنشئ حساب المستثمر",
    "auth.name": "الاسم الكامل",
    "auth.email": "البريد الإلكتروني",
    "auth.password": "كلمة المرور",
    "auth.phone": "الهاتف",
    "auth.login_btn": "دخول",
    "auth.register_btn": "إنشاء حسابي",
    "auth.no_account": "ليس لديك حساب؟",
    "auth.have_account": "مسجل بالفعل؟",
    "auth.forgot": "نسيت كلمة المرور؟",
    "auth.login_success": "تم تسجيل الدخول بنجاح",
    "auth.register_success": "تم إنشاء الحساب بنجاح",

    "dash.title": "فضاء المستثمر",
    "dash.welcome": "مرحباً",
    "dash.favorites": "عقاراتي المفضلة",
    "dash.no_favorites": "ليس لديك مفضلات بعد. استكشف عقاراتنا وأضف المفضلة لديك.",
    "dash.profile": "ملفي الشخصي",

    "admin.title": "إدارة YADIMMO",
    "admin.properties": "العقارات",
    "admin.leads": "طلبات الاتصال",
    "admin.users": "المستثمرون",
    "admin.new_property": "إضافة عقار",
    "admin.edit": "تعديل",
    "admin.delete": "حذف",
    "admin.save": "حفظ",
    "admin.cancel": "إلغاء",
    "admin.confirm_delete": "حذف هذا العقار؟",
    "admin.dashboard": "لوحة القيادة",
    "admin.new_leads": "جديدة",
    "admin.handle": "معالجة",
    "admin.added": "تمت إضافة العقار", "admin.modified": "تم تعديل العقار", "admin.deleted": "تم الحذف",
    "admin.f_title": "العنوان", "admin.f_desc": "الوصف", "admin.f_city": "المدينة", "admin.f_region": "الجهة",
    "admin.f_price": "الثمن (درهم)", "admin.f_surface": "المساحة م²", "admin.f_bedrooms": "غرف النوم", "admin.f_bathrooms": "حمامات",
    "admin.f_delivery": "التسليم", "admin.f_images": "صور العقار", "admin.f_features": "الخدمات (مفصولة بفواصل)",
    "admin.f_featured": "إبراز في الصفحة الرئيسية",
    "admin.tab_dossiers": "ملفات التمويل",
    "admin.search_ph": "البحث عن عقار…",
    "admin.bien": "العقار", "admin.col_contacts": "اتصالات", "admin.col_favoris": "المفضلة",
    "admin.col_rdv": "مواعيد", "admin.col_dossiers": "ملفات", "admin.status": "الحالة", "admin.client": "العميل",
    "admin.showing": "معروض",
    "admin.tab_rdv": "المواعيد",
    "admin.tab_chats": "محادثات",
    "rdv.accept": "قبول", "rdv.decline": "رفض", "rdv.reschedule": "تأجيل", "rdv.assign": "إسناد إلى",
    "rdv.unassigned": "غير مُسند", "rdv.when": "التاريخ", "rdv.subject": "الموضوع",
    "rdv.requested": "قيد الانتظار", "rdv.confirmed": "مؤكد", "rdv.rescheduled": "مؤجل", "rdv.declined": "مرفوض",
    "admin.upload_images": "رفع الصور", "admin.uploading": "جارٍ الرفع…", "admin.or_url": "أو ألصق روابط (رابط لكل سطر)",

    "footer.tagline": "نبني وننمو في كلمة واحدة.",
    "footer.rights": "جميع الحقوق محفوظة.",
    "footer.quick": "التنقل",
    "footer.contact": "اتصال",

    "common.loading": "جار التحميل...",
    "nav.cost": "تكلفة المعيشة", "nav.blog": "المدونة",
    "profiles.title": "أي مستثمر أنت؟",
    "profiles.subtitle": "المغرب يناسب كل مشروع حياة ومردودية.",
    "profiles.explore": "اكتشف",
    "profiles.retirement_t": "تقاعد تحت الشمس",
    "profiles.retirement_d": "اجعل المغرب إقامتك الرئيسية: مناخ لطيف، تكلفة معيشة أقل وإطار هادئ.",
    "profiles.secondary_t": "إقامة ثانوية",
    "profiles.secondary_d": "مقر مشمس على بعد ساعات من أوروبا، للسكن أو للكراء حسب رغبتك.",
    "profiles.rental_t": "استثمار كرائي",
    "profiles.rental_d": "مردودية جذابة في المدن الصاعدة. التدبير الكرائي تتكفل به YADIMMO.",
    "profiles.logistics_t": "لوجستيك استراتيجي",
    "profiles.logistics_d": "مستودعات على أبواب أوروبا (طنجة المتوسط)، بوابة نحو إفريقيا وآسيا.",
    "profiles.business_t": "توطين مقاولة",
    "profiles.business_d": "محلات ومناطق حرة لتطوير نشاطك، خدمة كونسيرج جاهزة.",
    "profiles.budget_t": "تحسين ميزانيتك",
    "profiles.budget_d": "قارن تكلفة المعيشة وتتبع سعر الدرهم/الأورو قبل الاستثمار.",
    "conv.note": "(سعر إرشادي)",
    "col.title": "تكلفة المعيشة والصرف",
    "col.subtitle": "تتبع سعر الدرهم المغربي مقابل الأورو وقارن تكلفة المعيشة في المغرب مع فرنسا. قدرة شرائية تغير كل شيء لمشروعك.",
    "col.compare": "المغرب مقابل فرنسا — المقارنة",
    "col.item": "البند", "col.morocco": "المغرب", "col.france": "فرنسا", "col.gap": "الفرق",
    "col.note": "قيم إرشادية محولة بالسعر المباشر. الأسعار الحقيقية تختلف حسب المدينة والفترة.",
    "col.cta_title": "مستعد للاستثمار بهذه القدرة الشرائية؟", "col.cta_btn": "اكتشف عقاراتنا",
    "col.rent": "كراء شقة غرفة واحدة (وسط)", "col.internet": "إنترنت ألياف", "col.electricity": "الكهرباء (منزل)",
    "col.fuel": "الوقود (بنزين)", "col.restaurant": "وجبة مطعم", "col.groceries": "مشتريات أسبوعية",
    "col.transport": "تذكرة نقل", "col.coffee": "قهوة",
    "col.per_month": "/ شهر", "col.per_liter": "/ لتر", "col.per_week": "/ أسبوع",
    "blog.title": "مدونة YADIMMO", "blog.subtitle": "نصائح وتحليلات وأدلة للاستثمار بثقة في عقارات المغرب.",
    "blog.read": "اقرأ", "blog.min": "دقيقة", "blog.all": "كل المقالات", "blog.generating": "جاري تحرير المقال…",
    "blog.cta_title": "ترغب في الاستثمار بالمغرب؟", "blog.cta_text": "فريقنا (إكس أون بروفانس ومراكش) يرافقك من الألف إلى الياء.", "blog.cta_btn": "عرض العقارات",
    "legal.eyebrow": "معلومات قانونية",
    "inv.title": "فضاء المستثمر",
    "inv.tab_project": "مشروعي", "inv.tab_appointments": "المواعيد", "inv.tab_alerts": "تنبيهاتي", "inv.tab_favorites": "المفضلة",
    "inv.tab_request": "طلب عقار",
    "req.title": "طلب عقار مخصص", "req.sub": "صف العقار الذي تبحث عنه وسيتواصل معك فريقنا بعروض مناسبة.",
    "req.type": "نوع العقار", "req.city": "المدينة المطلوبة", "req.budget": "الميزانية القصوى (درهم)", "req.msg": "حدد حاجتك (المساحة، الحي، الاستعمال…)",
    "req.submit": "إرسال الطلب", "req.sent": "تم إرسال الطلب! سيتواصل معك فريقنا.",
    "inv.fin_t": "شراء وتمويل", "inv.fin_d": "تكوين ملف القرض مع القرض الفلاحي المغربي.",
    "inv.plc_t": "استثمار / توظيف", "inv.plc_d": "احصل على نصيحة خبير حول توظيف عقاري.",
    "inv.imp_t": "توطين مقاولة", "inv.imp_d": "خدمة كونسيرج جاهزة لتوطين نشاطي بالمغرب.",
    "inv.dossier": "ملف التمويل", "inv.progress": "تقدم الملف", "inv.change": "تغيير المشروع",
    "inv.upload": "رفع", "inv.replace": "استبدال", "inv.submit": "إيداع ملفي في البنك", "inv.bank_note": "ملاحظة البنك:",
    "inv.appt_slots": "المواعيد المتاحة",
    "inv.appt_intro": "احجز موعداً مع خبير خدمة العملاء YADIMMO. الكونسيرج (النقل، الإقامة، الاكتشاف الميداني، التوطين الجاهز) يتكفل به فريقنا.",
    "inv.no_slots": "لا توجد مواعيد حالياً.", "inv.no_appt": "لا يوجد موعد. اختر موعداً في تبويب «مشروعي».",
    "inv.no_fav": "لا مفضلات بعد.", "inv.rdv_confirmed": "تم تأكيد الموعد",
    "inv.subject": "الموضوع", "inv.with": "مع", "inv.implantation": "توطين مقاولة", "inv.placement": "توظيف / استشارة",
    "st.draft": "مسودة", "st.submitted": "مودع في البنك", "st.in_review": "قيد الدراسة", "st.approved": "مقبول", "st.rejected": "مرفوض",
    "alerts.create": "إنشاء تنبيه", "alerts.city_ph": "المدينة (مثال مراكش)", "alerts.min_ph": "أدنى ميزانية (درهم)", "alerts.max_ph": "أقصى ميزانية (درهم)",
    "alerts.note_ph": "تفاصيل (اختياري)", "alerts.create_btn": "إنشاء التنبيه", "alerts.created": "تم إنشاء التنبيه. خدمة العملاء على علم بانتظاراتك.",
    "alerts.empty": "لا تنبيهات. يمكن لـ José إنشاء واحد لك عبر المحادثة.", "alerts.all_cities": "كل المدن", "alerts.type_any": "كل الأنواع",
    "svc.title": "لوحة قيادة الكونسيرج", "svc.role": "خدمة العملاء",
    "svc.tab_rdv": "المواعيد", "svc.tab_slots": "الفترات", "svc.tab_leads": "العملاء المحتملون", "svc.tab_expect": "انتظارات العملاء",
    "svc.add_slot": "إضافة فترة (45 دقيقة)", "svc.add": "إضافة", "svc.slot_added": "تمت إضافة الفترة",
    "svc.no_rdv": "لا موعد مبرمج.", "svc.no_slots": "لا فترة متاحة. أضف من الأعلى.",
    "svc.no_leads": "لا عميل محتمل.", "svc.no_expect": "لا انتظارات مسجلة.",
    "svc.via_jose": "عبر José", "svc.mark_handled": "معالج", "svc.handled": "معالج", "svc.prospect": "عميل محتمل",
    "bank.title": "ملفات التمويل", "bank.eyebrow": "الفضاء البنكي", "bank.empty": "لا ملف مودع بعد.",
    "bank.review": "وضع قيد الدراسة", "bank.approve": "قبول", "bank.reject": "رفض", "bank.missing": "ناقص", "bank.view": "عرض",
    "bank.note_prompt": "ملاحظة للمستثمر (اختياري):", "bank.updated": "تم تحديث الحالة", "st.saved": "تم الحفظ",
    "common.mad": "درهم",
    "common.eur": "€",
  },
};

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("yad_lang") || "fr");

  useEffect(() => {
    localStorage.setItem("yad_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = useCallback((key) => {
    return (translations[lang] && translations[lang][key]) || translations.fr[key] || key;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, isRTL: lang === "ar" }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within LanguageProvider");
  return ctx;
};

export const LANGS = ["fr", "en", "ar"];
